import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  useTranslation,
} from "react-i18next";

import {
  useSelector,
  useDispatch,
} from "react-redux";

import {
  useNavigate,
} from "react-router-dom";

import {
  DataGrid,
} from "@mui/x-data-grid";

import {
  ThemeProvider,
  createTheme,
  Button,
} from "@mui/material";

import {
  toast,
} from "react-toastify";

import {
  motion,
} from "framer-motion";

import {
  FiUsers,
  FiGrid,
  FiPlus,
  FiArrowLeft,
  FiArrowRight,
  FiUser,
} from "react-icons/fi";

import {
  MdOutlineFoodBank,
  MdOutlineLocalOffer,
} from "react-icons/md";

import {
  IoMdClose,
  IoCheckmarkSharp,
} from "../utils/icons";

import {
  Loader,
} from "../../components/utils";

import {
  useStateContext,
} from "../../context/ContextProvider";

import {
  media,
} from "../../server";

import {
  UsersFilter,
} from "./utils";

import {
  getFillterUsers,
} from "../../redux/actions/user";

import {
  getAllMeals,
} from "../../redux/actions/meals";

import {
  getAllCategorys,
} from "../../redux/actions/category";

import {
  getAllFeaturedMeals,
} from "../../redux/actions/featuredMeals";

import {
  EditButtonStyle,
  EditonBlur,
  EditonFocus,
  EditonMouseEnter,
  EditonMouseLeave,
  localeTextGrid,
} from "../../constants";


function DashboardHero() {
  const {
    t,
  } = useTranslation();

  const dispatch =
    useDispatch();

  const navigate =
    useNavigate();

  const {
    currentDir,
  } = useStateContext();


  const isRTL =
    currentDir === "rtl";


  const DirectionArrow =
    isRTL
      ? FiArrowLeft
      : FiArrowRight;


  /* =====================================
      FILTER STATES
  ====================================== */

  const [
    name,
    setName,
  ] = useState("");

  const [
    email,
    setEmail,
  ] = useState("");

  const [
    phoneNumber,
    setPhoneNumber,
  ] = useState("");


  const [
    paginationModel,
    setPaginationModel,
  ] = useState({
    pageSize: 10,
    page: 0,
  });


  const page =
    paginationModel.page;

  const limit =
    paginationModel.pageSize;


  /* =====================================
      REDUX
  ====================================== */

  const {
    isLoading,
    FillterUsers,
    pagination,
    totalusers,
    errfiter,
  } = useSelector(
    (state) =>
      state.Users
  );


  const {
    totalMeals,
    totalmeals,
  } = useSelector(
    (state) =>
      state.Meals
  );


  const {
    totalFeaturedMeals,
  } = useSelector(
    (state) =>
      state.FeaturedMeals
  );


  const {
    totalcategorys,
  } = useSelector(
    (state) =>
      state.Categorys
  );


  const users =
    Array.isArray(
      FillterUsers
    )
      ? FillterUsers
      : [];


  /* =====================================
      LOAD DASHBOARD COUNTS
  ====================================== */

  useEffect(() => {

    dispatch(
      getAllFeaturedMeals()
    );

    dispatch(
      getAllMeals(
        0,
        1
      )
    );

    dispatch(
      getAllCategorys()
    );

  }, [
    dispatch,
  ]);


  /* =====================================
      LOAD USERS
  ====================================== */

  useEffect(() => {

    dispatch(
      getFillterUsers(
        page,
        limit,
        phoneNumber,
        email,
        name
      )
    );

  }, [
    page,
    limit,
    phoneNumber,
    email,
    name,
    dispatch,
  ]);


  /* =====================================
      USER ERROR
  ====================================== */

  useEffect(() => {

    if (errfiter) {
      toast.error(
        errfiter
      );
    }

  }, [
    errfiter,
  ]);


  /* =====================================
      STATISTICS
  ====================================== */

  const statistics = [
    {
      id: "users",

      title: t(
        "Users"
      ),

      value:
        totalusers || 0,

      icon: FiUsers,

      description:
        t(
          "Registered users"
        ),
    },

    {
      id: "categories",

      title: t(
        "categorys"
      ),

      value:
        totalcategorys ||
        0,

      icon: FiGrid,

      description:
        t(
          "Meal categories"
        ),
    },

    {
      id: "meals",

      title: t(
        "meals"
      ),

      value:
        totalMeals ??
        totalmeals ??
        0,

      icon:
        MdOutlineFoodBank,

      description:
        t(
          "Restaurant meals"
        ),
    },

    {
      id: "offers",

      title: t(
        "Featured Meals"
      ),

      value:
        totalFeaturedMeals ||
        0,

      icon:
        MdOutlineLocalOffer,

      description:
        t(
          "Active offers"
        ),
    },
  ];


  /* =====================================
      EDIT USER
  ====================================== */

  const updateUserHandler =
    (id) => {

      navigate(
        `/EditUserRolePage/${id}`
      );

    };


  /* =====================================
      MUI
  ====================================== */

  const theme =
    useMemo(
      () =>
        createTheme({
          direction:
            currentDir,
        }),
      [
        currentDir,
      ]
    );


  /* =====================================
      TABLE COLUMNS
  ====================================== */

  const columns =
    useMemo(
      () => [

        {
          field: "name",

          headerName:
            t("Name"),

          width: 210,

          filterable:
            false,

          renderCell: (
            params
          ) => (

            <div
              className="
                flex
                h-full

                items-center

                gap-3
              "
            >

              <div
                className="
                  flex

                  w-9
                  h-9

                  shrink-0

                  items-center
                  justify-center

                  rounded-full

                  bg-color-1/10

                  text-color-1
                "
              >
                <FiUser />
              </div>


              <span
                className="
                  font-kufi
                  font-medium

                  text-sm
                "
              >
                {
                  params.value
                }
              </span>

            </div>

          ),
        },


        {
          field: "email",

          headerName:
            t("Email"),

          width: 240,

          filterable:
            false,

          renderCell: (
            params
          ) => (

            <div
              className="
                flex
                h-full

                items-center

                font-kufi
                text-sm
              "
            >
              {
                params.value ||
                "-"
              }
            </div>

          ),
        },


        {
          field:
            "phoneNumber",

          headerName:
            t(
              "phone Number"
            ),

          width: 190,

          filterable:
            false,

          renderCell: (
            params
          ) => (

            <div
              dir="ltr"

              className="
                flex
                h-full

                items-center

                font-medium
                text-sm
              "
            >
              {
                params.value ||
                "-"
              }
            </div>

          ),
        },


        {
          field:
            "createdAt",

          headerName:
            t(
              "created At"
            ),

          width: 160,

          filterable:
            false,

          renderCell: (
            params
          ) => {

            if (
              !params.value
            ) {
              return "-";
            }


            const date =
              new Date(
                params.value
              );


            const formatted =
              date.toLocaleDateString(
                isRTL
                  ? "ar-EG"
                  : "en-GB",

                {
                  day:
                    "2-digit",

                  month:
                    "2-digit",

                  year:
                    "numeric",
                }
              );


            return (
              <div
                className="
                  flex
                  h-full

                  items-center

                  font-kufi
                  text-sm
                "
              >
                {formatted}
              </div>
            );
          },
        },


        {
          field: "role",

          headerName:
            t(
              "is Admin"
            ),

          width: 130,

          filterable:
            false,

          renderCell: (
            params
          ) => {

            const isAdmin =
              params.value !==
              "user";


            return (
              <div
                className="
                  flex
                  h-full

                  items-center
                "
              >

                <div
                  className={`
                    flex

                    w-8
                    h-8

                    items-center
                    justify-center

                    rounded-full

                    ${
                      isAdmin
                        ? `
                          bg-green-500/10
                          text-green-600
                        `
                        : `
                          bg-red-500/10
                          text-red-500
                        `
                    }
                  `}
                >
                  {isAdmin ? (
                    <IoCheckmarkSharp />
                  ) : (
                    <IoMdClose />
                  )}
                </div>

              </div>
            );
          },
        },


        {
          field:
            "avatar",

          headerName:
            t("Image"),

          width: 100,

          sortable:
            false,

          filterable:
            false,

          renderCell: (
            params
          ) => (

            <div
              className="
                flex
                h-full

                items-center
              "
            >

              {params.value ? (

                <img
                  src={`${media}${params.value}`}

                  alt={
                    params.row
                      ?.name ||
                    "User"
                  }

                  className="
                    w-11
                    h-11

                    rounded-xl

                    object-cover

                    border
                    border-color-1/10
                  "
                />

              ) : (

                <div
                  className="
                    flex

                    w-11
                    h-11

                    items-center
                    justify-center

                    rounded-xl

                    bg-color-1/10

                    text-color-1
                  "
                >
                  <FiUser />
                </div>

              )}

            </div>

          ),
        },


        {
          field:
            "actions",

          headerName:
            t("Actions"),

          width: 130,

          sortable:
            false,

          filterable:
            false,

          renderCell: (
            params
          ) => (

            <div
              className="
                flex
                h-full

                items-center
              "
            >

              <Button
                className="
                  rounded-full
                "

                style={
                  EditButtonStyle
                }

                onMouseEnter={
                  EditonMouseEnter
                }

                onMouseLeave={
                  EditonMouseLeave
                }

                onFocus={
                  EditonFocus
                }

                onBlur={
                  EditonBlur
                }

                onClick={() =>
                  updateUserHandler(
                    params.row._id
                  )
                }
              >
                <span
                  className="
                    body-2
                  "
                >
                  {t("Edit")}
                </span>
              </Button>

            </div>

          ),
        },

      ],

      [
        t,
        isRTL,
      ]
    );


  const totalItems =
    pagination
      ?.totalItems ||
    0;


  return (
    <div
      className="
        w-full

        px-4
        sm:px-6
        lg:px-8

        py-8
        lg:py-10
      "
    >

      <div
        className="
          max-w-[1600px]

          mx-auto
        "
      >

        {/* =================================
            WELCOME HERO
        ================================= */}

        <motion.section
          initial={{
            opacity: 0,
            y: 20,
          }}

          animate={{
            opacity: 1,
            y: 0,
          }}

          className="
            relative

            overflow-hidden

            rounded-[2rem]

            bg-color-2

            px-6
            py-7

            md:px-9
            md:py-9

            text-white

            shadow-[0_20px_60px_rgba(68,37,20,.16)]

            mb-7
          "
        >

          <div
            className="
              absolute

              -top-28
              -end-20

              w-72
              h-72

              rounded-full

              bg-color-1/20

              blur-[90px]
            "
          />


          <div
            className="
              relative
              z-10

              flex
              flex-col

              md:flex-row
              md:items-center
              md:justify-between

              gap-6
            "
          >

            <div>

              <span
                className="
                  font-kufi
                  text-xs

                  text-color-1
                "
              >
                {t(
                  "Yaman Management"
                )}
              </span>


              <h1
                className="
                  mt-2

                  font-kufi
                  font-bold

                  text-2xl
                  md:text-3xl
                "
              >
                {t(
                  "Welcome to Yaman Dashboard"
                )}
              </h1>


              <p
                className="
                  max-w-xl

                  mt-3

                  font-kufi
                  text-xs
                  md:text-sm

                  leading-7

                  text-white/55
                "
              >
                {t(
                  "Manage meals categories offers and restaurant content from one place"
                )}
              </p>

            </div>


            <button
              type="button"

              onClick={() =>
                navigate(
                  "/CreateMealPage"
                )
              }

              className="
                group

                flex

                min-h-[48px]

                items-center
                justify-center

                gap-2

                rounded-full

                bg-color-1

                px-5

                font-kufi
                text-sm

                text-white

                transition-all

                hover:bg-white
                hover:text-color-2
              "
            >
              <FiPlus />

              {t(
                "Create Meal"
              )}

              <DirectionArrow
                className="
                  transition-transform

                  group-hover:translate-x-1
                "
              />
            </button>

          </div>

        </motion.section>


        {/* =================================
            STAT CARDS
        ================================= */}

        <section
          className="
            grid

            grid-cols-2
            xl:grid-cols-4

            gap-3
            md:gap-5

            mb-8
          "
        >

          {statistics.map(
            (
              item,
              index
            ) => {

              const Icon =
                item.icon;


              return (
                <motion.div
                  key={
                    item.id
                  }

                  initial={{
                    opacity: 0,
                    y: 20,
                  }}

                  animate={{
                    opacity: 1,
                    y: 0,
                  }}

                  transition={{
                    delay:
                      index *
                      0.06,
                  }}

                  whileHover={{
                    y: -4,
                  }}

                  className="
                    group

                    relative

                    overflow-hidden

                    rounded-[1.5rem]

                    border
                    border-color-2/10
                    dark:border-white/10

                    bg-back-primery
                    dark:bg-back-darksecondary

                    p-4
                    md:p-5

                    shadow-[0_10px_30px_rgba(68,37,20,.05)]

                    transition-all

                    hover:border-color-1/30
                  "
                >

                  <div
                    className="
                      flex
                      items-start
                      justify-between

                      gap-3
                    "
                  >

                    <div>

                      <span
                        className="
                          block

                          text-2xl
                          md:text-3xl

                          font-bold

                          text-tcolor-4
                          dark:text-white
                        "
                      >
                        {
                          item.value
                        }
                      </span>


                      <span
                        className="
                          block

                          mt-1

                          font-kufi
                          font-semibold

                          text-[10px]
                          md:text-xs

                          text-tcolor-4
                          dark:text-white/80
                        "
                      >
                        {
                          item.title
                        }
                      </span>

                    </div>


                    <div
                      className="
                        flex

                        w-10
                        h-10

                        md:w-12
                        md:h-12

                        shrink-0

                        items-center
                        justify-center

                        rounded-2xl

                        bg-color-1/10

                        text-lg
                        md:text-xl

                        text-color-1

                        transition-all

                        group-hover:bg-color-1
                        group-hover:text-white
                      "
                    >
                      <Icon />
                    </div>

                  </div>


                  <p
                    className="
                      hidden
                      sm:block

                      mt-4

                      font-kufi
                      text-[9px]

                      text-n-5
                      dark:text-white/35
                    "
                  >
                    {
                      item.description
                    }
                  </p>


                  <span
                    className="
                      absolute

                      bottom-0
                      start-0

                      w-10
                      h-[2px]

                      bg-color-1

                      transition-all

                      group-hover:w-full
                    "
                  />

                </motion.div>
              );
            }
          )}

        </section>


        {/* =================================
            QUICK ACTIONS
        ================================= */}

        <section
          className="
            grid

            md:grid-cols-3

            gap-3

            mb-8
          "
        >

          <QuickAction
            icon={
              FiPlus
            }

            title={t(
              "Create Meal"
            )}

            description={t(
              "Add a new meal"
            )}

            onClick={() =>
              navigate(
                "/CreateMealPage"
              )
            }
          />


          <QuickAction
            icon={
              MdOutlineFoodBank
            }

            title={t(
              "All Meals"
            )}

            description={t(
              "Manage restaurant meals"
            )}

            onClick={() =>
              navigate(
                "/DAllMealsPage"
              )
            }
          />


          <QuickAction
            icon={
              MdOutlineLocalOffer
            }

            title={t(
              "Create Offer"
            )}

            description={t(
              "Create a featured offer"
            )}

            onClick={() =>
              navigate(
                "/CreateFeaturedMealsPage"
              )
            }
          />

        </section>


        {/* =================================
            USERS SECTION
        ================================= */}

        <section
          className="
            overflow-hidden

            rounded-[2rem]

            border
            border-color-2/10
            dark:border-white/10

            bg-back-primery
            dark:bg-back-darksecondary

            shadow-[0_15px_45px_rgba(68,37,20,.06)]
          "
        >

          {/* Users Header */}

          <div
            className="
              flex
              flex-col

              md:flex-row
              md:items-center
              md:justify-between

              gap-4

              px-5
              md:px-7

              py-6

              border-b
              border-color-2/10
              dark:border-white/10
            "
          >

            <div
              className="
                flex
                items-center

                gap-3
              "
            >

              <div
                className="
                  flex

                  w-11
                  h-11

                  items-center
                  justify-center

                  rounded-2xl

                  bg-color-1/10

                  text-color-1
                "
              >
                <FiUsers />
              </div>


              <div>

                <h2
                  className="
                    font-kufi
                    font-semibold

                    text-lg

                    text-tcolor-4
                    dark:text-white
                  "
                >
                  {t(
                    "Users Management"
                  )}
                </h2>


                <p
                  className="
                    mt-1

                    font-kufi
                    text-[10px]

                    text-n-5
                    dark:text-white/35
                  "
                >
                  {totalItems}{" "}
                  {t(
                    "registered users"
                  )}
                </p>

              </div>

            </div>

          </div>


          {/* Filters */}

          <div
            className="
              px-4
              md:px-6

              py-5

              bg-color-1/[0.025]
            "
          >
       
          </div>


          {/* Table */}

          <ThemeProvider
            theme={theme}
          >

            <div
              className="
                w-full

                overflow-x-auto

                p-3
                md:p-5
              "
            >

              <DataGrid
                rows={
                  users
                }

                columns={
                  columns
                }

                getRowId={(
                  row
                ) =>
                  row._id
                }

                disableRowSelectionOnClick

                disableColumnSelector

                pagination

                paginationMode="server"

                rowCount={
                  totalItems
                }

                paginationModel={
                  paginationModel
                }

                onPaginationModelChange={
                  setPaginationModel
                }

                pageSizeOptions={[
                  10,
                  20,
                  50,
                ]}

                localeText={
                  localeTextGrid
                }

                loading={
                  isLoading
                }

                rowHeight={
                  68
                }

                sx={{
                  minWidth:
                    "1200px",

                  border:
                    "none",

                  "& .MuiDataGrid-columnHeaders":
                    {
                      backgroundColor:
                        "rgba(165,119,58,.06)",

                      borderRadius:
                        "14px",
                    },

                  "& .MuiDataGrid-columnHeaderTitle":
                    {
                      fontFamily:
                        "inherit",

                      fontWeight:
                        600,
                    },

                  "& .MuiDataGrid-cell":
                    {
                      borderColor:
                        "rgba(68,37,20,.07)",
                    },

                  "& .MuiDataGrid-row:hover":
                    {
                      backgroundColor:
                        "rgba(165,119,58,.04)",
                    },

                  "& .MuiDataGrid-footerContainer":
                    {
                      borderColor:
                        "rgba(68,37,20,.08)",
                    },
                }}
              />

            </div>

          </ThemeProvider>

        </section>

      </div>
    </div>
  );
}


/* =====================================
    QUICK ACTION COMPONENT
====================================== */

function QuickAction({
  icon: Icon,
  title,
  description,
  onClick,
}) {
  return (
    <motion.button
      type="button"

      whileHover={{
        y: -3,
      }}

      whileTap={{
        scale: 0.98,
      }}

      onClick={
        onClick
      }

      className="
        group

        flex

        items-center

        gap-4

        rounded-[1.4rem]

        border
        border-color-2/10
        dark:border-white/10

        bg-back-primery
        dark:bg-back-darksecondary

        p-4

        text-start

        transition-all

        hover:border-color-1/30
        hover:shadow-[0_12px_35px_rgba(68,37,20,.06)]
      "
    >

      <div
        className="
          flex

          w-11
          h-11

          shrink-0

          items-center
          justify-center

          rounded-2xl

          bg-color-1

          text-white
        "
      >
        <Icon />
      </div>


      <div
        className="
          min-w-0
        "
      >

        <h3
          className="
            font-kufi
            font-semibold

            text-xs
            md:text-sm

            text-tcolor-4
            dark:text-white
          "
        >
          {title}
        </h3>


        <p
          className="
            mt-1

            font-kufi
            text-[9px]

            text-n-5
            dark:text-white/35
          "
        >
          {description}
        </p>

      </div>

    </motion.button>
  );
}


export default DashboardHero;